// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 417 ? "setting" : chunkId) + "." + {"0":"6e6fda44","112":"600ade4e","417":"80d087b8","626":"d480170c"}[chunkId] + ".js";
};